import { cn } from "@/lib/utils";

interface JobVisualProps {
  imageUrl?: string;
  title: string;
  className?: string;
  imageClassName?: string;
}

export function JobVisual({ imageUrl, title, className, imageClassName }: JobVisualProps) {
  return (
    <div className={cn("relative aspect-square overflow-hidden rounded-2xl border border-gray-700 bg-gradient-to-br from-cyan-500/10 via-gray-900 to-purple-500/10", className)}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={title}
          className={cn("h-full w-full object-cover", imageClassName)}
          onError={(e) => {
            const target = e.target as HTMLImageElement;
            target.style.display = "none";
            const fallback = target.nextElementSibling as HTMLElement | null;
            fallback?.classList.remove("hidden");
          }}
        />
      ) : null}

      {/* Gradient-only fallback when no image */}
      <div className={cn("absolute inset-0 bg-gradient-to-br from-cyan-600/15 to-purple-600/15", imageUrl ? "hidden" : "")} aria-hidden />
    </div>
  );
}
